import React from 'react' 
import './index.css'

function Loader() {
    return (
        <div className="loader">
            <div className="balls">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader